import * as React from 'react';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import type { FreeBusyType } from '../../index';
import { getFreeBusyItemBarStyling } from 'owa-freebusy-style';
import {
    ShowAsBarProps,
    ShowAsType,
    ShowAsBarStyleProps,
    ShowAsBarStyles,
} from './ShowAsBar.types';

const getClassNames = classNamesFunction<ShowAsBarStyleProps, ShowAsBarStyles>();

/** The base non-styled version of ShowAsBar. */
export function ShowAsBarBase(props: ShowAsBarProps) {
    const { styles, theme, className, showAs = ShowAsType.NoInformation } = props;
    const classNames = getClassNames(styles, { theme: theme!, className, showAs });
    const freeBusyStyling =
        showAs != ShowAsType.OutsideWorkingHours
            ? {
                  ...getFreeBusyItemBarStyling(
                      ShowAsType[showAs] as FreeBusyType,
                      props.colorScheme
                  ),
                  borderColor: props.colorScheme.calPrimary,
              }
            : undefined;
    const { style } = props;
    const finalStyle = { ...style, ...freeBusyStyling };
    return <div className={classNames.root} style={finalStyle} />;
}
